// @flow
import { toggleExtrusionRaw } from 'actions/map';

export const RT_SET_FOLLOWED_AIRCRAFT = 'rt/SET_FOLLOWED_AIRCRAFT';
export const RT_SET_FEATURES = 'rt/SET_FEATURES';

export function setFollowedAircraft(followedAircraft) {
  return dispatch => {
    dispatch({
      type: RT_SET_FOLLOWED_AIRCRAFT,
      followedAircraft:
        followedAircraft !== null ? followedAircraft.toString() : null,
    });
  };
}

export function setFeatures(features) {
  return {
    type: RT_SET_FEATURES,
    features,
  };
}



// WEBPACK FOOTER //
// ./actions/rt.js